module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/2note"
    }
  }, [_vm._v("Publisher’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/5chap1#chap1"
    }
  }, [_vm._v("At North Farm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/6chap2#chap2"
    }
  }, [_vm._v("Rain Moving In")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/7chap3#chap3"
    }
  }, [_vm._v("The Songs We Know Best")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/8chap4#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When the Sun Went Down")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/9chap5#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Landscape (After Baudelaire)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/10chap6#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just Walking Around")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11chap7#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Fly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12chap8#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ongoing Story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13chap9#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thank You For Not Cooperating")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14chap10#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("But What Is the Reader To Make of This?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15chap11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Down by the Station, Early in the Morning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16chap12#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Around the Rough and Rugged Rocks the Ragged Rascal Rudely Ran")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17chap13#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Pleasant Adventures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18chap14#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Purists Will Object")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/19chap15#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Description of a Masque")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/20chap16#chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Path to the White Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/21chap17#chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ditto, Kiddo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/22chap18#chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/23chap19#chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I See, Said the Blind Man, as He Put Down His Hammer and Saw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/24chap20#chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edition Peters, Leipzig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/25chap21#chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37 Haiku")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/26chap22#chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haibun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/27chap23#chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haibun 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/28chap24#chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haibun 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/29chap25#chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haibun 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/30chap26#chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haibun 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/31chap27#chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haibun 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/32chap28#chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Variation on a Noel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/33chap29#chap29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Staffage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/34chap30#chap30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lonedale Operator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/35chap31#chap31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proust’s Questionnaire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/36chap32#chap32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cups with Broken Handles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/37chap33#chap33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just Someone You Say Hi To")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/38chap34#chap34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Like")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/39chap35#chap35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So Many Lives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/40chap36#chap36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Never Seek to Tell Thy Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/41chap37#chap37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Darlene’s Hospital")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/42chap38#chap38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Destiny Waltz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/43chap39#chap39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Try Me! I’m Different!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/44chap40#chap40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One of the Most Extraordinary Things in Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/45chap41#chap41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whatever It Is, Wherever You Are")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/46chap42#chap42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trefoil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/47chap43#chap43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/48chap44#chap44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Wave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff173f34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4TOC.vue
// module id = 66
// module chunks = 0